import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SetupStepBlockProps } from "./types";

export const SetupStepBlock = ({
  number,
  title,
  state,
  answeredCount,
  totalCount,
  children,
}: SetupStepBlockProps) => {
  const { t } = useTranslation();
  const percent = totalCount ? Math.round((answeredCount / totalCount) * 100) : state === "done" ? 100 : 0;

  return (
    <section
      data-testid={`setup-step-${number}`}
      data-state={state}
      className={`rounded-lg border px-3 py-2.5 transition-colors ${
        state === "active"
          ? "border-blue-400 bg-blue-50/40 shadow-sm"
          : state === "done"
            ? "border-emerald-200 bg-white"
            : "border-slate-200 bg-slate-50 opacity-60"
      }`}
    >
      <div className="flex items-center gap-2">
        <span
          className={`flex h-6 w-6 flex-none items-center justify-center rounded-full text-[12px] font-bold ${
            state === "done"
              ? "bg-emerald-500 text-white"
              : state === "active"
                ? "bg-blue-600 text-white"
                : "bg-slate-200 text-slate-500"
          }`}
        >
          {state === "done" ? <Check size={14} aria-hidden /> : number}
        </span>
        <span className="min-w-0 flex-1 truncate text-[14px] font-semibold text-slate-800">{title}</span>
        {totalCount > 0 && (
          <span className="flex-none text-[12px] tabular-nums text-slate-500">
            {t("smartSurveyor.cablesBeta.setupProgressCount", { answered: answeredCount, total: totalCount })}
          </span>
        )}
      </div>
      <div className="mt-2 h-1 overflow-hidden rounded-full bg-slate-200">
        <div
          className={`h-full rounded-full transition-all duration-700 ${
            state === "done" ? "bg-emerald-500" : "bg-blue-500"
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className="mt-2 flex flex-col gap-1.5">{children}</div>
    </section>
  );
};
